// initial state
// shape: [{ id, quantity }]
import {
    isMobile
} from "@/utils/other.js";
import {
    fetchAdvByTypes
} from "@/apis/home";
import {
    catchError
} from "@/utils/base/base";

const state = {
    advList: [],
}

const isMobileDev = isMobile()

// getters
const getters = {
    allAdvList: (state) => {
        return state.advList
    },
    homePCAdvList: (state) => {
        const homePCAdvDatasource = state.advList.find(item => Number(item.type) === isMobileDev ? 2 : 1)
        return homePCAdvDatasource ? homePCAdvDatasource.data : []
    },
    homePCCenterBannerList: (state) => {
        const bannerList = state.advList.find(item => Number(item.type) === 3 || Number(item.type) === 4)
        return bannerList ? bannerList.data : []
    },
    industPCAdvList: (state) => {
        const advList = state.advList.find(item => Number(item.type) === 5)
        return advList ? advList.data : []
    },
    // 产品列表广告图
    productAdvList: (state) => {
        const advList = state.advList.find(item => Number(item.type) === 13 || Number(item.type) === 14)
        return advList ? advList.data : []
    },
    // 知识分享广告图
    knowledegeShareAdvList: (state) => {
        const advList = state.advList.find(item => Number(item.type) === 11 || Number(item.type) === 12)
        return advList ? advList.data : []
    },
    // 荣誉资质广告图
    companyHonorAdvList: (state) => {
        const advList = state.advList.find(item => Number(item.type) === 18 || Number(item.type) === 17)
        return advList ? advList.data : []
    },
    // 产品供应广告图
    supplyProductAdvList: (state) => {
        const advList = state.advList.find(
            item => Number(item.type) === 19 || Number(item.type) === 20
        )
        return advList ? advList.data : []
    },
    // 新闻列表广告图
    newsListAdvList: (state) => {
        const advList = state.advList.find(
            item => Number(item.type) === 21 || Number(item.type) === 22
        )
        return advList ? advList.data : []
    },
}

// actions
const actions = {
    async getSetAllAdv({
        commit
    }) {
        try {
            const {
                returnData
            } = await fetchAdvByTypes({});

            commit('setAdvList', returnData)

        } catch (error) {
            catchError(error);
        }
    },
}

// mutations
const mutations = {
    setAdvList(state, advList) {
        state.advList = advList
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}